import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';

import s from './ErrorBoundaryFallback.module.css';

interface ErrorBoundaryFallbackProps {
  title: string;
  message: string;
  metaInfo?: string;
}

export const ErrorBoundaryFallback = ({
  message,
  metaInfo,
  title,
}: ErrorBoundaryFallbackProps) => {
  return (
    <Flex className={s.container} direction="column">
      <Flex direction="column" padding={['px-24', 'py-32']} gap="g-16">
        <h2 className={s.title}>
          <Icon name="warning" size="font" />
          {title}
        </h2>
        <p className={s.message}>{message}</p>
      </Flex>
      {metaInfo && (
        <footer className={s.footer}>
          <pre>{metaInfo}</pre>
        </footer>
      )}
    </Flex>
  );
};
